import axios from "axios";
import { CONTRACT_ADDRESS } from "../../constants/tokens";
import { TRONSCAN_API_ADDRESS } from "../../constants/config";
import {
  formatDecimal,
  divide,
  formatAbbr,
  formatLocalBalance,
  multiply,
} from "../../utils/formatNumber";

export class TokenHoldersService {
  public fetchDistribution = async (params) => {
    try {
      const { token, tokenSupply } = params;

      const queryString = `?tokenId=${CONTRACT_ADDRESS[token]}`;
      const { data } = await axios.get(
        `${TRONSCAN_API_ADDRESS}/tokens/position-distribution${queryString}`
      );

      const { first, second, third, fourth } = {
        first: formatDecimal(data["rank1-10"]),
        second: formatDecimal(data["rank11-50"]),
        third: formatDecimal(data["rank51-100"]),
        fourth: formatDecimal(data["rank101-500"]),
      };

      const total = formatDecimal(tokenSupply);
      const fifth = total - first - second - third - fourth;

      const { firstShare, secondShare, thirdShare, fourthShare, fifthShare } = {
        firstShare: multiply(divide(first, total), 100).toFixed(2),
        secondShare: multiply(divide(second, total), 100).toFixed(2),
        thirdShare: multiply(divide(third, total), 100).toFixed(2),
        fourthShare: multiply(divide(fourth, total), 100).toFixed(2),
        fifthShare: multiply(divide(fifth, total), 100).toFixed(2),
      };

      return {
        distribution: {
          first: {
            value: formatAbbr(first),
            share: firstShare,
          },
          second: {
            value: formatAbbr(second),
            share: secondShare,
          },
          third: {
            value: formatAbbr(third),
            share: thirdShare,
          },
          fourth: {
            value: formatAbbr(fourth),
            share: fourthShare,
          },
          fifth: {
            value: formatAbbr(fifth),
            share: fifthShare,
          },
          total: tokenSupply,
        },
      };
    } catch (e) {
      console.log(e);
      throw new Error("Error connecting to transaction service");
    }
  };

  public fetchTokenHolders = async (params) => {
    try {
      const { token, tokenSupply, start, limit } = params;

      const queryString = `?sort=-balance&start=${start}&limit=${limit}&&contract_address=${CONTRACT_ADDRESS[token]}`;
      const { data } = await axios.get(
        `${TRONSCAN_API_ADDRESS}/token_trc20/holders${queryString}`
      );

      const { rangeTotal, total, trc20_tokens } = data;

      const holders = trc20_tokens.map((user, index) => {
        return {
          rank: start + index + 1,
          address: user.holder_address,
          balance: formatLocalBalance(formatDecimal(user.balance)),
          percentage: multiply(divide(user.balance, tokenSupply), 100).toFixed(
            6
          ),
        };
      });

      return {
        data: holders,
        rangeTotal,
        total,
      };
    } catch (e) {
      console.log(e);
      throw new Error("Error connecting to transaction service");
    }
  };
}
